import React, { useEffect } from 'react';
import { Building2, Users, Shield, TrendingUp, Phone, Mail, FileText, Award } from 'lucide-react';
import smilingDoctor from '../../assets/smiling-female-doctor.jpg'
import smilingDoctor2 from '../../assets/smile_girl_2.jpg'
import family from '../../assets/family-sofa.jpg'
import nurse from '../../assets/nurse-hijab.jpg'
import proffessionals from '../../assets/hospital-professional.jpg'
import medicine from '../../assets/medicines.jpg'
import useProviderTypeStore from '../../store/providerTypeStore';
import fmcLogo from '../../assets/fmc_logo.JPG';

export default function ProviderEmpanelment() {
    const currentYear = new Date().getFullYear();
    const yearsOfExperience = currentYear - 1997;
    const { fetchProviderTypes } = useProviderTypeStore();

    const handleGoToForm = () => {
        window.location.href = '/#step-1';
    };
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    }, []);
    // Initialize data fetching
    useEffect(() => {
        fetchProviderTypes();
    }, [fetchProviderTypes]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-primary/10 via-white to-primary/10 ">

            {/* Hero Section with Improved Circular Image Layout */}
            <section className="relative py-40 overflow-hidden">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
                    <h1 className="text-5xl md:text-5xl font-bold text-gray-900 mb-1 leading-tight">
                        FMC Network UAE
                    </h1>

                    <h2 className="text-3xl md:text-3xl font-bold text-gray-900 mb-6 leading-tight">
                        Provider Empanelment
                    </h2>
                    <p className="text-lg text-gray-600 mb-10 max-w-3xl mx-auto">
                        Join our esteemed Providers Panel                   </p>
                    <button
                        onClick={handleGoToForm}
                        className="bg-primary hover:bg-primary text-white px-12 py-5 rounded-full text-xl font-semibold transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
                    >
                        Get Started
                    </button>

                </div>

                {/* Enhanced Decorative Circular Images - Better Alignment & Modern 2024+ Photos */}
                <div className="absolute inset-0 pointer-events-none">
                    {/* 1. Top Left - Smiling Female Nurse/Doctor → ROUND */}
                    <div className="absolute top-8 left-8 w-52 h-52 rounded-full overflow-hidden shadow-2xl border-8 border-white">
                        <img
                            src={smilingDoctor}
                            className="w-full h-full object-cover"
                            alt="Smiling doctor"
                        />
                    </div>

                    {/* 2. Mid Left - Professional Female → PHONE SHAPE */}
                    <div className="absolute top-48 left-20 w-60 h-[300px] rounded-[3rem] overflow-hidden shadow-2xl border-[12px] border-white">
                        {/* Optional: slight inner shadow / screen feel */}
                        <div className="absolute inset-0 bg-black/5 pointer-events-none z-10" />
                        <img
                            src={nurse}
                            className="w-full h-full object-cover"
                            alt="Female medical professional"
                        />
                    </div>

                    {/* 3. Top Right - Confident Male Doctor → ROUND (from here on all round) */}
                    <div className="absolute top-20 right-12 w-56 h-56 rounded-full overflow-hidden shadow-2xl border-8 border-white">
                        <img
                            src={proffessionals}
                            className="w-full h-full object-cover"
                            alt="Male doctor"
                        />
                    </div>

                    {/* 4. Mid Right - Modern Stethoscope / Medicine → ROUND */}
                    <div className="absolute top-48 right-64 w-48 h-48 rounded-full overflow-hidden shadow-2xl border-8 border-white bg-gradient-to-br from-yellow-300 to-amber-400 flex items-center justify-center">
                        <img
                            src={medicine}
                            className="w-4/5 h-4/5 object-contain"
                            alt="Medical symbol"
                        />
                    </div>

                    {/* 5. Bottom Left - Family → ROUND */}
                    <div className="absolute -bottom-4 left-6 w-52 h-52 rounded-full overflow-hidden shadow-2xl border-8 border-white">
                        <img
                            src={family}
                            className="w-full h-full object-cover"
                            alt="Family healthcare"
                        />
                    </div>

                    {/* 6. Bottom Right - Large Smiling Doctor → ROUND */}
                    <div className="absolute bottom-8 right-4 w-80 h-80 rounded-full overflow-hidden shadow-3xl border-8 border-white">
                        <img
                            src={smilingDoctor2}
                            className="w-full h-full object-cover"
                            alt="Smiling female doctor"
                        />
                    </div>

                    {/* Subtle decorative background circles */}
                    <div className="absolute top-32 left-48 w-32 h-32 rounded-full bg-emerald-100 opacity-40"></div>
                    <div className="absolute bottom-48 right-64 w-40 h-40 rounded-full bg-teal-100 opacity-30"></div>
                    <div className="absolute top-80 right-20 w-24 h-24 rounded-full bg-amber-100 opacity-50"></div>
                </div>

            </section>
            {/* Why Partner Section - Clean & Beautiful */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
                    {/* Heading */}
                    <div className="text-center mb-16 md:mb-20">
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
                            Why Choose FMC Network?
                        </h2>
                    </div>

                    {/* Cards Grid */}
                    <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
                        {/* Card 1 */}
                        <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 overflow-hidden">
                            <div className="pt-10 pb-10 px-8 text-center">
                                <div className="mx-auto w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors duration-300">
                                    <Users className="w-10 h-10 text-blue-600" />
                                </div>
                                <h3 className="mt-6 text-2xl font-bold text-gray-900">
                                    10M+ Insured Members
                                </h3>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 overflow-hidden">
                            <div className="pt-10 pb-10 px-8 text-center">
                                <div className="mx-auto w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors duration-300">
                                    <Building2 className="w-10 h-10 text-orange-600" />
                                </div>
                                <h3 className="mt-6 text-2xl font-bold text-gray-900">
                                    5,000+ Network Providers
                                </h3>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 overflow-hidden">
                            <div className="pt-10 pb-10 px-8 text-center">
                                <div className="mx-auto w-20 h-20 rounded-full bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100 transition-colors duration-300">
                                    <Award className="w-10 h-10 text-indigo-600" />
                                </div>
                                <h3 className="mt-6 text-2xl font-bold text-gray-900">
                                    {yearsOfExperience}+ Years of Excellence
                                </h3>
                            </div>
                        </div>

                        {/* Card 4 */}
                        <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 overflow-hidden">
                            <div className="pt-10 pb-10 px-8 text-center">
                                <div className="mx-auto w-20 h-20 rounded-full bg-purple-50 flex items-center justify-center group-hover:bg-purple-100 transition-colors duration-300">
                                    <Shield className="w-10 h-10 text-purple-600" />
                                </div>
                                <h3 className="mt-6 text-2xl font-bold text-gray-900">
                                    Regulatory Compliance
                                </h3>
                            </div>
                        </div>

                        {/* Card 5 */}
                        <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 overflow-hidden">
                            <div className="pt-10 pb-10 px-8 text-center">
                                <div className="mx-auto w-20 h-20 rounded-full bg-teal-50 flex items-center justify-center group-hover:bg-teal-100 transition-colors duration-300">
                                    <FileText className="w-10 h-10 text-teal-600" />
                                </div>
                                <h3 className="mt-6 text-2xl font-bold text-gray-900">
                                    ISO Certified
                                </h3>
                            </div>
                        </div>

                        {/* Card 6 */}
                        <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 overflow-hidden">
                            <div className="pt-10 pb-10 px-8 text-center">
                                <div className="mx-auto w-20 h-20 rounded-full bg-emerald-50 flex items-center justify-center group-hover:bg-emerald-100 transition-colors duration-300">
                                    <TrendingUp className="w-10 h-10 text-emerald-600" />
                                </div>
                                <h3 className="mt-6 text-2xl font-bold text-gray-900">
                                    Fast & Prompt Payments
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Footer */}
            <footer className="bg-secondary-dark text-white py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Logo & Tagline */}
                    <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 mb-2">
                        <img
                            src={fmcLogo}
                            alt="FMC Network UAE Logo"
                            className="h-16 sm:h-20 w-auto object-contain"
                        />
                    </div>

                    {/* Intro Text with better line breaks */}
                    <p className="text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto sm:mx-0 text-center sm:text-left">
                        FMC Network UAE MC LLC is registered as a Medical Insurance TPA under all licensing Authorities in UAE<br />
                        Central Bank of UAE : 001<br />
                        Dubai Health Authority : TPA010<br />
                        Department of Health Abu Dhabi : C006
                    </p>

                    {/* Grid - Offices with contact info */}
                    <div className="grid md:grid-cols-2 gap-10 lg:gap-16 text-center md:text-left">
                        {/* Dubai Office */}
                        <div>
                            <h3 className="text-2xl font-bold mb-6 text-teal-400">Dubai Office</h3>
                            <p className="text-gray-300 leading-relaxed mb-6">
                                501, 5th Floor, Fahidi Heights,<br />
                                Khalid Bin Al Waleed Road, Bank Street,<br />
                                Bur Dubai, P.O. Box: 50430
                            </p>
                            <div className="space-y-4 text-gray-200">
                                <div className="flex items-center justify-center md:justify-start gap-3">
                                    <Phone className="w-5 h-5 text-teal-400 flex-shrink-0" />
                                    <span>+97143977841</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start gap-3">
                                    <Mail className="w-5 h-5 text-teal-400 flex-shrink-0" />
                                    <span>customercare@fmchealthcare.ae</span>
                                </div>
                            </div>
                        </div>

                        {/* Abu Dhabi Office */}
                        <div>
                            <h3 className="text-2xl font-bold mb-6 text-teal-400">Abu Dhabi Office</h3>
                            <p className="text-gray-300 leading-relaxed mb-6">
                                Abdul Raheem Al Ali Building, M-2,<br />
                                Mezzanine Floor, Al Muroor Road,<br />
                                Opposite Al Falah Etisalat, P.O. Box: 127452
                            </p>
                            <div className="space-y-4 text-gray-200">
                                <div className="flex items-center justify-center md:justify-start gap-3">
                                    <Phone className="w-5 h-5 text-teal-400 flex-shrink-0" />
                                    <span>+97126414104</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start gap-3">
                                    <Mail className="w-5 h-5 text-teal-400 flex-shrink-0" />
                                    <span>customercare@fmchealthcare.ae</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="border-t border-secondary mt-16 pt-10 text-center text-white">
                        <p>© {new Date().getFullYear()} FMC Network MC LLC UAE</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}